import UnionFilterIcon from '../../../../../assets/svgs/UnionFilter'

import style from './style.module.css'

/** The mobile segmented control. Values match the page's quickFilter state. */
const QUICK_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'saved', label: 'Saved' },
  { value: 'hiring', label: 'Hiring' },
]

const FilterHeader = ({ quickFilter, setQuickFilter, onOpenFilter, activeFilterCount }) => {
  return (
    <div className={style.filterHeader}>
      <div className={style.filterHeader_buttons} role="group" aria-label="Quick filters">
        {QUICK_FILTERS.map((option) => {
          const isActive = quickFilter === option.value
          return (
            <button
              key={option.value}
              type="button"
              className={`${style.filterHeader_button} ${isActive ? style.active : ''}`}
              onClick={() => setQuickFilter(option.value)}
              aria-pressed={isActive}
              data-log-action="spotlight_quick_filter"
            >
              <span>{option.label}</span>
            </button>
          )
        })}
      </div>

      <button
        type="button"
        className={style.filterHeader_trigger}
        onClick={onOpenFilter}
        aria-label={
          activeFilterCount > 0
            ? `Open filters, ${activeFilterCount} active`
            : 'Open filters'
        }
        data-log-action="spotlight_open_filter"
      >
        <span className={style.filterHeader_triggerLabel}>
          Filter
          <UnionFilterIcon />
        </span>
        {activeFilterCount > 0 && (
          <span className={style.filterHeader_badge} aria-hidden="true">
            {activeFilterCount}
          </span>
        )}
      </button>
    </div>
  )
}

export default FilterHeader
